import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Container, Box } from '@mui/material';

// Components
import EINSHeader from './EINSHeader';
import EINSSidebar from './EINSSidebar';

// Pages
import EINSDashboard from '../pages/EINSDashboard';
import EINSTransactions from '../pages/EINSTransactions';
import EINSBlocks from '../pages/EINSBlocks';
import EINSMyInfo from '../pages/EINSMyInfo';
import PartnerIntegrationPrototype from '../pages/PartnerIntegrationPrototype';

// 📌 단순화: 전역 폴링 제거

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

interface EINSMainProps {
  user: UserInfo;
  onLogout: () => void;
}

function EINSMain({ user, onLogout }: EINSMainProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const isIntegrationPrototype = location.pathname === '/integration-prototype';

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    // 📌 단순화: PollingProvider 제거
    <Box sx={{ display: 'flex' }}>
        <EINSHeader
          user={user}
          onMenuClick={toggleSidebar}
          onLogout={onLogout}
        />
        <EINSSidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <Container 
          component="main" 
          maxWidth={isIntegrationPrototype ? false : 'xl'}
          disableGutters={isIntegrationPrototype}
          sx={{ 
            flexGrow: 1, 
            padding: '24px',
            marginTop: 9,  // Header height adjustment
            marginLeft: sidebarOpen ? 15 : 8,  // Sidebar state optimization
            marginRight: 8,  // Right margin
            transition: 'margin-left 0.3s ease'
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<EINSDashboard user={user} />} />
            <Route path="/transactions" element={<EINSTransactions user={user} />} />
            <Route path="/blocks" element={<EINSBlocks user={user} />} />
            <Route path="/my-blocks" element={<Navigate to="/blocks" replace />} />
            <Route path="/integration-prototype" element={<PartnerIntegrationPrototype partner="eINS" user={user} />} />
            <Route path="/my-info" element={<EINSMyInfo user={user} />} />
            <Route path="/info" element={<Navigate to="/my-info" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Container>
      </Box>
  );
}

export default EINSMain;
